import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { CompanyAccount, ACHFromAccount, Account, Participant } from "model";

export default function CaptureTemplateDetailsACHParticipantsGroupFiltered(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const achFromAccount = ACHFromAccount.init({ account: Account.initByID(5).id, id: ACHFromAccount.nextID() });
  const participants = Participant.initAll().map(item => {
    // "isSelected" will be used to keep track of row selection.
    item.isSelected = undefined;
    return item;
  }).filter(item => {
    return item.group === "Employee";
  });

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update(["template", "secCode"], "PPD Credit - Consumer Credit")
    .update(["template", "name"], "New Payroll")
    .update(["template", "companyDiscretionaryData"], "Bi-Weekly")
    .update(["template", "companyEntryDescription"], "Payroll")
    .update(["template", "companyAccount"], CompanyAccount.initByID(0))
    .update(["achFromAccounts", "accounts"], [achFromAccount])
    .update(["groupSearchValue"], "Employee")
    .update(["participants"], participants)
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showSecCode", "isActive"], true)
    .update(["showOneTimeACHModal", "isActive"], false)
    .update(["achParticipantsModalIsOpen", "isActive"], true)
    .submit();

  return (
    <TemplateDetailsPage ui={ui} data={data} />
  )
}
